module.exports = __webpack_public_path__ + "img/20.96253de2.webp";